<div class="dashboard home-wrapper">
    <div class="floating-message mobile-hidden" (click)="goToOldPortal()">
        <div>
            Volver a la versión tradicional
        </div>
    </div>
    <div class="row mb-2 mobile-hidden dashboard--header">
        <div class="col-md-6 col-xs-12">
            <sc-title type="h2" content="Portal de productores"></sc-title>
        </div>
        <div class="dashboard--header--buttons">
            <sc-button [id]="'mesa_de_ayuda'" type="link-secondary" prefixIcon="question-elipse" class="md-1"
                (onClick)="handleHelp()">
                Mesa de ayuda
            </sc-button>
            <sc-old-car-quotation>
            </sc-old-car-quotation>
        </div>
    </div>
    <div class="row mb-2 first">
        <div class="col-12 mb-1 desktop-hidden dashboard-banner" (click)="goToPersonalizeYourBrochures()">
            <img src="assets/images/home/banner_folletos_mobile.png" class="dashboard-banner__image"
                alt="Adherite a póliza digital">
        </div>
        <div class="col-md-9 col-12">
            <div class="row ">
                <div class="mb-1 col-md-4 col-6 col-sm-6 text-center" *ngFor="let cardItem of cardItems">
                    <div class="dashboard--card" id="{{cardItem.id}}" (click)="onHandleCardClick(cardItem)">
                        <img [src]="cardItem.image" class="dashboard--card__image" [alt]="cardItem.label">
                        <span class="dashboard--card__title">{{cardItem.label}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="mb-1 col-md-3 col-xs-12 mobile-hidden">
            <div class="dashboard-banner dashboard-banner--clickable" (click)="goToPersonalizeYourBrochures()">
                <div class="dashboard-banner__image-wrapper">
                    <img src="assets/images/home/banner_folletos_texto.png" class="dashboard-banner__image"
                        alt="Adherite a póliza digital">
                </div>
            </div>
        </div>
        <div class="w-100 px-1 desktop-hidden">
            <sc-button [id]="'mesa_de_ayuda'" type="link-secondary" prefixIcon="question-elipse" class="md-1"
                (onClick)="handleHelp()">
                Mesa de ayuda
            </sc-button>
            <sc-old-car-quotation>
            </sc-old-car-quotation>
        </div>
    </div>
    <div class="row mobile-hidden">
        <div class="col-md-4 col-xs-12">
            <p class="mb-1 dashboard--news__title">
                Renovamos la página de inicio
            </p>
            <p class="mb-1 dashboard--news__subtitle">
                Rediseñamos la home del Portal para hacerte las cosas más simples.
            </p>
            <sc-button id="link_novedades" type="link" (onClick)="goToNews()">Más Información</sc-button>
        </div>
        <div class="col-md-4 col-xs-12">
            <p class="mb-1 dashboard--news__title">
                Denuncia de otros riesgos
            </p>
            <p class="mb-1 dashboard--news__subtitle">
                Ya podés ingresar las denuncias de otros riesgos a través del Portal.
            </p>
            <sc-button type="link" (onClick)="goToNews()">Más Información</sc-button>
        </div>
        <div class="col-md-4 col-xs-12">
            <p class="mb-1 dashboard--news__title">
                Nuevo cotizador de comercios
            </p>
            <p class="mb-1 dashboard--news__subtitle">
                Ahora el cotizador de Integral de comercios, es más rápido y facil.
            </p>
            <sc-button type="link" (onClick)="goToNews()">Más información</sc-button>
        </div>
    </div>
</div>


<!-- WELCOME MODAL -->
<sc-modal-2 class="modal modal-new" id="welcomeModal" [blocking]="true" [options]="modalOperationOptions"
    (onModalClose)="onHandleNewsClick()">
    <h3>Novedades de la plataforma</h3>
    <div class="modal-new--loading mt-sm-2" *ngIf="!isIframeNewsLoaded">
        <span class="sc-icon icon-loading sc-icon-2x spinner color-brand-01"></span>
    </div>
    <iframe *ngIf="newsUrl" title="Iframe Modal News"
        [ngClass]="{ 'hidden': !isIframeNewsLoaded, 'showing':isIframeNewsLoaded }"
        class="modal-new--iframe pr-sm-2 pl-sm-2" [attr.src]="newsUrl | safe" (load)="onIframeNewsLoad($event)">
    </iframe>
    <div *ngIf="newsUrl" [ngClass]="{ 'hidden': !isIframeNewsLoaded, 'showing':isIframeNewsLoaded }"
        class="modal-new--buton-container">
        <sc-button-2 id="button_entendido_novedades" type="btn-primary" body="Entendido!"
            (onClick)="onHandleNewsClick()">
        </sc-button-2>
    </div>
</sc-modal-2>

<!-- OLD PORTAL VERSION MODAL -->
<sc-modal-2 class="modal" id="backToOldPortal" [blocking]="true" [options]="backOldPortalModalOptions">
    <div class="row old-version-modal--position">
        <img src="assets/images/oldPortal.svg" alt="">
    </div>
    <div class="row old-version-modal--position">
        <h2 class="old-version-modal--title">Estás por volver a la versión anterior</h2>
    </div>
    <div class="row old-version-modal--position">
        <p class="old-version-modal--sub-title">Comentanos por qué te gustaría volver<br> a la versión anterior.</p>
    </div>
    <div class="row old-version-modal--position old-version-modal--position_textarea">
        <textarea [(ngModel)]="messageBackToOldPortal" placeholder="Porque...">
            </textarea>
    </div>
    <div class="row old-version-modal--position old-version-modal--position_buttons">
        <sc-button-2 id="confirmar-vuelta-viejo-portal" class="old-version-modal--position_buttons_space"
            [disabled]="messageBackToOldPortal === ''" type="btn-primary" body="Confirmar" isFullWidth="true"
            (onClick)="onConfirmOldPortal()">
        </sc-button-2>
        <sc-button-2 id="cancelar-vuelta-viejo-portal" type="btn-secondary" body="Cancelar" isFullWidth="true"
            (onClick)="onModalOldPortalCancel()">
        </sc-button-2>
    </div>
</sc-modal-2>